import React, {
  useState,
  useEffect,
  useRef,
  useMemo
} from 'react';

// DATA TABLE
import ControldocDataTable from "../../../controldoc/datatable";

const BulkRequestDocumentEntityTab = props => {
  const {
    bulkRequest,
    setBulkRequest,
    dataTableConfiguration: {
      columns: dataTableColumns
    },
    actions: {
      indexEntitiesPath
    },
    configuration: {
      defaultRequestParams,
      entity: entityConfiguration
    }
  } = props;

  const { key: entityKey } = entityConfiguration;

  const entitiesErrors = () => {
    if(_.has(bulkRequest, 'errors.entity_items')){
      return(
        <div className="alert alert-danger">
          <ul className='mb-0'>
            { _.map(bulkRequest.errors.entity_items, (error) => {
              return(
                <li key={ _.uniqueId("entityError-") }>
                  { error }
                </li>
              )
            })}
          </ul>
        </div>
      )
    }
  }

  const onSelectionChange = selectedRecords => {
    setBulkRequest(prevState => {
      return {
        ...prevState,
        [entityKey]: selectedRecords
      }
    })
  }

  const controldocDataTableContext = useMemo(() => {
    if(props?.configuration?.context == 'laboral_bulk'){
      return 'laboral'
    }
  }, [props?.configuration?.context])

  return(
    <div className="row">
      <div className="col-12">
        { entitiesErrors() }
        <ControldocDataTable
          columns={ dataTableColumns }
          configuration={{
            showDistributionListFilter: props?.configuration?.showDistributionListFilter,
            showGridlines: true,
            context: controldocDataTableContext,
            fetchRecords: {
              endpoint: indexEntitiesPath,
              keyName: entityKey,
              defaultRequestParams: defaultRequestParams
            },
            selectable: {
              enabled: true,
              mode: 'multiple',
              selection: bulkRequest[entityKey],
              onSelectionChange: onSelectionChange
            }
          }}
        >
        </ControldocDataTable>
      </div>
    </div>
  )
}

export default BulkRequestDocumentEntityTab;
